<template>
    <tenants-current>
        <tenants-find
            slot-scope="{ data: current_tenant }"
            :params="{ tenant: current_tenant.uuid }"
            :include="[
                'alerts(paginate:1,3)',
                'tasks(paginate:1,5)',
            ]"
        >
            <div
                slot-scope="{
                    data: tenant,
                    meta,
                    error,
                    is_loading,
                    has_loaded,
                    find
                }"
            >
                <template v-if="!has_loaded || error">
                    <base-loading
                        :error="error"
                        :retry="find"
                        class="py-6"
                    />

                    <error-modal
                        v-if="error"
                        :error="error"
                    />
                </template>

                <template v-else>
                    <base-hint name="tenants-overview-index">
                        <template slot="heading">
                            Welcome to Rentora, {{ tenant.first_name }}!
                        </template>

                        <p class="mb-3">
                            We’ve added hints like this one throughout your dashboard to help you settle in. In no time you'll be paying your rent, viewing inventories and more.
                        </p>

                        <p class="lg:hidden">
                            Feel free to explore your dashboard by tapping the
                            <base-svg
                                name="icon-menu"
                                class="inline-block w-5 h-5 -mt-1"
                            />
                            icon at the top of the page, and clicking the links in the menu.
                        </p>

                        <p class="hidden lg:block">
                            Feel free to explore your dashboard by clicking the links in the menu to the left.
                        </p>
                    </base-hint>

                    <alerts-card
                        :data="tenant.alerts.data"
                        :meta="tenant.alerts.meta"
                        class="mb-6"
                    />

                    <events-calendar
                        class="mb-6"
                    />

                    <tasks-card
                        :data="tenant.tasks.data"
                        :meta="tenant.tasks.meta"
                        class="mb-6"
                    />
                </template>
            </div>
        </tenants-find>
    </tenants-current>
</template>

<script>
    import AlertsCard from '../../../../components/alerts-card'
    import EventsCalendar from '../../_/overview/index/events-calendar'
    import TenantsCurrent from '../../../../components/tenants-current'
    import TenantsFind from '../../../../components/tenants-find'
    import TasksCard from '../../../../components/tasks-card'

    export default {
        components: {
            AlertsCard,
            EventsCalendar,
            TenantsCurrent,
            TenantsFind,
            TasksCard
        }
    }
</script>
